import { useContext, useState } from 'react';
import { Box, Button, Dialog, DialogContent, IconButton, Typography, useTheme } from '@mui/material';
import { LocalizationContext } from '@context/LocalizationContext';
import CloseIcon from '@mui/icons-material/Close';
import { refineFonts } from '@/Theming/refineFonts';
import { useAnalytics } from '@hooks/useAnalytics';
import { REFINE_ANALYTICS_EVENTS } from '@/types/RefineAnalyticsEvents';

export const OUCFDeadlineDialogVariant = () => {
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const { HowMuchTimeDoIHave } = useContext(LocalizationContext);
	const theme: any = useTheme();
	const { trackRefineEvent } = useAnalytics();

	const handleOpenDialog = () => {
		setIsDialogOpen(true);
		trackRefineEvent(REFINE_ANALYTICS_EVENTS.OUCF_CUSTOMER_OPENS_DEADLINE_TEXT);
	};

	return (
		<>
			<Box paddingTop={'24px'}>
				<Button
					onClick={handleOpenDialog}
					variant={'text'}
					sx={{
						color: theme.palette.primary.main,
						padding: 0,
						textDecoration: 'underline',
						...refineFonts.mediumRegular,
					}}>
					{HowMuchTimeDoIHave.ButtonText}
				</Button>
			</Box>
			<Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
				<IconButton
					onClick={() => setIsDialogOpen(false)}
					sx={{
						position: 'absolute',
						right: 8,
						zIndex: 1,
						top: 8,
					}}>
					<CloseIcon />
				</IconButton>
				<DialogContent sx={{ paddingTop: '40px', paddingBottom: '56px' }}>
					<Typography sx={{ ...refineFonts.xLargeBold, paddingBottom: '8px' }}>
						{HowMuchTimeDoIHave.ButtonText}
					</Typography>
					<Typography
						dangerouslySetInnerHTML={{ __html: HowMuchTimeDoIHave.MainText }}
						sx={{ ...refineFonts.mediumRegular }}
					/>
				</DialogContent>
			</Dialog>
		</>
	);
};
